
  
  //PRODUCT THUMBNAILS SLIDER INITIALIZE JAVASCRIPT END

$(document).ready(function () {
  var rtlFlag = $('body').hasClass('lang-rtl') ? true : false;

    $('.reassurance-list').owlCarousel({
        nav: false,
        navText: [
          '<i class=\'fa fa-arrow-left\'></i>',
          '<i class=\'fa fa-arrow-right\'></i>'
        ],
        dots: true,
        loop: false,
        margin: 15,
        autoplay: true,
        autoplayTimeout: 5000,
        rtl: rtlFlag,
        rewind: true,
        autoHeight: true, // Auto adjust height based on content
        onChanged: function () {
          setTimeout(function () {
            $('.reassurance-list').trigger('refresh.owl.carousel');
          }, 100); // Increased timeout to 100 milliseconds
        },
        responsive: {
          0: {
            items: 1
          },
          320: {
            items: 1
          }
        }
      });
  
  //BACK TO TOP JAVASCRIPT START
  $(window).scroll(function () {
    if ($(this).scrollTop() > 500) {
      $('#slidetop').fadeIn(500);
    } else {
      $('#slidetop').fadeOut(500);
    }
  });
  $('#slidetop').click(function (e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: 0
    }, 800);
  });
  //BACK TO TOP JAVASCRIPT END
  
   //DISABLED ZOOM FOR VIDEO JAVASCRIPT START
  $(".product__media-item").click(function(){
    if($(this).attr("data-media-type") == 'video'){
      $('.zoomContainer').hide();
    }else{
      $('.zoomContainer').show();
    }
  });
   //DISABLED ZOOM FOR VIDEO JAVASCRIPT END
  
  //DEFAULT COLLAPSE JAVASCRIPT START
  $(document).on("click","[data-toggle='collapse']",function() {
    var parent = $(this).data("parent");
    var target = $(this).data("href");
    if($(parent).length && $(parent).hasClass('panel-group')) {
     $(parent+" .panel").each(function() {
       var p = $(this).find("[data-toggle='collapse']");
       var t = p.data("href");
       if(t!= target && p.attr("aria-expanded") == "true") {
        $(t).slideUp().removeClass("in");
        p.addClass("ishi-collapsed").attr("aria-expanded","false");
       } 
     });
    } 
    if($(this).attr("aria-expanded") == "false") {
      $(target).slideDown().addClass("in");
      $(this).removeClass("ishi-collapsed").attr("aria-expanded","true");
    } else {
      $(target).slideUp().removeClass("in");
      $(this).addClass("ishi-collapsed").attr("aria-expanded","false");
    }
  });
  //DEFAULT COLLAPSE JAVASCRIPT END
  
  //DEFAULT POPOVER JAVASCRIPT START
  $(document).on("click","[data-toggle='popover']",function() {
    var target = $(this).data("href");
    if($(this).attr("aria-expanded") == "false") {
      $(target).addClass("active");
      $(this).attr("aria-expanded","true");
    } else {
      $(target).removeClass("active");
      $(this).attr("aria-expanded","false");
    }
  });
  $(document).on("click", function(event){
    
    if(!$(event.target).closest('#user-notification').length && !$(event.target).closest('[data-href="#user-notification"]').length){
      if($('[data-href="#user-notification"]').attr("aria-expanded") == "true") {
        $("#user-notification").removeClass("active");
        $('[data-href="#user-notification"]').attr("aria-expanded","false");
        event.preventDefault();
      }
    }
  
    if(!$(event.target).closest('#HeaderCountryList').length && !$(event.target).closest('[data-href="#HeaderCountryList"]').length){
      if($('[data-href="#HeaderCountryList"]').attr("aria-expanded") == "true") {
        $("#HeaderCountryList").removeClass("active");
        $('[data-href="#HeaderCountryList"]').attr("aria-expanded","false");
      }
    }
    
    if(!$(event.target).closest('#HeaderLanguageList').length && !$(event.target).closest('[data-href="#HeaderLanguageList"]').length){
      if($('[data-href="#HeaderLanguageList"]').attr("aria-expanded") == "true") {
        $("#HeaderLanguageList").removeClass("active");
        $('[data-href="#HeaderLanguageList"]').attr("aria-expanded","false");
      }
    }

});

  $(document).on("click", ".search-toggle", function() {
  $("#search-container-full").addClass("active");
  $(".search-overlay").addClass("active");
  $("body").addClass("active-popup"); // Add this line to disable scrolling
});

$(document).on("click", function(event) {
  if (
    !$(event.target).closest("#search-container-full").length &&
    !$(event.target).closest('[data-href="#search-container-full"]').length
  ) {
    if ($('[data-href="#search-container-full"]').attr("aria-expanded") == "true") {
      $("#search-container-full").removeClass("active");
      $('[data-href="#search-container-full"]').attr("aria-expanded", "false");
      $(".search-overlay").removeClass("active");
      $("body").removeClass("active-popup"); 
    }
  }
});

$(document).on("click", "#ModalClose-search", function() {
  $("#search-container-full").removeClass("active");
  $(".search-overlay").removeClass("active");
  $("body").removeClass("active-popup"); 
});
  
$(document).on("click", function(event) {
  if (
    !$(event.target).closest("#search-container-full").length &&
    !$(event.target).closest('.search-toggle').length
  ) {
    if ($("#search-container-full").hasClass("active")) {
      $("#search-container-full").removeClass("active");
      $(".search-overlay").removeClass("active");
      $("body").removeClass("active-popup"); 
    }
  }
});
  
  //DEFAULT POPOVER JAVASCRIPT END
  
  //DEFAULT TABS JAVASCRIPT START
  $(document).on("click",".ishi-nav-link",function() {
    $(this).parents(".ishi-nav-tabs").find(".ishi-tab-item").removeClass("active");
    $(this).parents(".ishi-tab-item").addClass("active");
    
    $(this).parents(".ishi-product-tab").find(".ishi-tab-pane").removeClass("active");
    var target = $(this).data("href");
    $(target).addClass("active");
  });
  //DEFAULT TABS JAVASCRIPT END
  
  //DEFAULT PANEL JAVASCRIPT START
  $(document).on("click",'[data-action="ishi-panel"]',function() {
    var target = $(this).attr("aria-controls");
    $(this).parents(".ishi-panel-container").find(".ishi-panel-data").removeClass("active");
    $(target).addClass("active");
  });
  //DEFAULT PANEL JAVASCRIPT END
  
  //DEFAULT WISHLIST JS START  
  if($(".add-in-wishlist-js").length != 0) {
    $(document).on("click", ".add-in-wishlist-js", function(event){
    if($(this).hasClass("added-wishlist")) return true;
    event.preventDefault();
    try {
      var id = $(this).data('href');
      if(getTheCookie("wishlist") == null) {
        var str = id;
      } else {
        if(getTheCookie("wishlist").indexOf(id) == -1) {
          var str = getTheCookie("wishlist") + '__' + id;
        }
      }
      setTheCookie("wishlist", str, 14);
      $('.loadding-wishbutton-'+id).show();
      $('.default-wishbutton-'+id).remove();
      setTimeout(function(){ 
        $('.loadding-wishbutton-'+id).remove(); $('.added-wishbutton-'+id).show();
                           
      }, 2000);
     } catch (err) {
        console.log("error reading wishlist cookies!");
     }
    });
  }
  setupWishlistButtons();
  //DEFAULT WISHLIST JS END
  
  //CART PAGE EDIT BUTTON JAVASCRIPT START
  $(document).on("click",".js-edit-toggle",function() {
    $(this).parents("tr").toggleClass("cart__update--show");
    $(this).toggleClass("cart__edit--active");
  });
  //CART PAGE EDIT BUTTON JAVASCRIPT END
  
  //STOCK URGENCY START
      var stock = parseInt($("#variant-stock").html());
      var maxqty = parseInt($(".selected-variant").data("quantity"));
      if(stock == '' || stock <= 0) {
        $(".ishi-progress-content").addClass('hidden');
      }
      switch(stock){case 9:$("#ishi-progress-bar span").css("width","65%");break;case 8:$("#ishi-progress-bar span").css("width","60%");break;case 7:$("#ishi-progress-bar span").css("width","55%");break;case 6:$("#ishi-progress-bar span").css("width","50%");break;case 5:$("#ishi-progress-bar span").css("width","40%");break;case 4:$("#ishi-progress-bar span").css("width","30%");break;case 3:$("#ishi-progress-bar span").css("width","20%");break;case 2:$("#ishi-progress-bar span").css("width","10%");break;case 1:$("#ishi-progress-bar span").css("width","5%");break;default:$("#ishi-progress-bar span").css("width","90%")}
  //STOCK URGENCY END
  
  
  // PRODUCT THUMBNAILS SLIDER INITIALIZE JAVASCRIPT START
 $(document).ready(function() { 
    var mainCarousel = $('.single-product');
    var thumbnailCarousel = $('.product__media-list');
    mainCarousel.owlCarousel({
      items: 1,
    nav: true,
    navText: [
         '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
         '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M5 12H19M19 12L12 19M19 12L12 5" stroke="" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg>'
    ],
    dots: false,
    loop: false,
    margin:15,
    rewind:true,
      autoHeight:true,
      rtl: rtlFlag
    }).on('changed.owl.carousel', function(event) {
        var index = event.item.index;
        thumbnailCarousel.trigger('to.owl.carousel', [index, 300, true]);
    });

    thumbnailCarousel.owlCarousel({
        items: 4,
        margin: 10,
        dots: false,
        nav: false,
    rtl:rtlFlag,
    responsive: {
          0: { items: 3 },
          544: { items: 4 },
          768: { items: 3 },
          992: { items: $('#shopify-section-Ishi_sidebar').length ? 3 : 4 },
          1200: { items: 4 }
    }
    }).on('click', '.owl-item', function() {
      var index = $(this).index();
      mainCarousel.trigger('to.owl.carousel', [index, 300, true]);
    });
  });
  
  //PRODUCT THUMBNAILS SLIDER INITIALIZE JAVASCRIPT END

  

  //PRODUCT THUMBNAILS SLIDER INITIALIZE JAVASCRIPT END
  
  //COLLECTION GRID-LIST JAVASCRIPT START
  $(document).on("click",".collectiongrid-layout",function() {
    var id = $(this).data("id");
    setTheCookie("collectiongrid-layout", id, 14);
    setGridLayout();
  });
  setGridLayout();
  //COLLECTION GRID-LIST JAVASCRIPT END
  
  
  //CART BUTTONS SCRIPT START
  $(document).on("click", ".add-to-cart-js", function () {
  var variantID = this.getAttribute("data-variantid");
  $(this).addClass("loading");
  addToCartJS(1, variantID, this);
});
  
  $(document).on("click",".combo-add-to-cart-btn",function() {
    $(this).addClass("loading");
    var items = [];
    $(this).parents(".product-main").find("li").each(function( index ) {
     var variantID=  $(this).data("variantid");
      console.log(variantID);
     items.push({quantity : 1, id:variantID});
    });
    addToCartComboJS(items, this);
  });
  
  $(document).on("click",".cart-remove-js",function() {
  	var variantID = this.getAttribute("data-variantid");
    removeFromCartJS(variantID);
  });

  $(document).on("click",".minicart-quantity__button",function() {
    var variantID = this.getAttribute("data-variantid");
    var quantity = $(this).parents(".quantity").find(".quantity__input").val();
    updateCartItemJS(quantity, variantID);
});
$(document).on("click","quickview-opener .product-popup-modal__button",function() {
    $(".quantity__input").val(1);
});
  
  //CART BUTTONS SCRIPT END
  
  //QUICKVIEW SCRIPT START
  $(document).on("click",".quick-view",function() {
  	var handle = $(this).data("handle");
    loadQuickView(handle, $(this));
  });
  //QUICKVIEW SCRIPT END
  
  //SIDEBAR FILTERS SCRIPT START 
  if($("#FacetFiltersFormSidebar [type='checkbox']:checked").length) {
    $("#FacetFiltersFormSidebar .clear-all").css("display","inline-block");
  }
//   $(document).on('change',"#SortBy", function() {
//     $("#FacetFiltersFormSidebar [type='checkbox']:checked").each(function( index ) {
//       $(this).parents("label").trigger("click");
//     });
//   }); 
  //SIDEBAR FILTERS SCRIPT END 
  
  // INITIALIZE JS START
  $( ".owl-carousel.slider-with-options" ).each(function( index ) {
    $(this).owlCarousel({
      lazyLoad:true,
      navText: [
       '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.08359 6.33805C0.79806 6.03797 0.809844 5.56325 1.10992 5.27771L5.99987 0.624662C6.29994 0.339128 6.77467 0.350913 7.0602 0.650985C7.34574 0.951057 7.33395 1.42578 7.03388 1.71132L2.68725 5.84736L6.8233 10.194C7.10883 10.4941 7.09705 10.9688 6.79698 11.2543C6.49691 11.5399 6.02218 11.5281 5.73664 11.228L1.08359 6.33805ZM11.6151 6.81922L1.60831 6.57081L1.64553 5.07127L11.6523 5.31969L11.6151 6.81922Z" /></svg>',
      '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.9164 6.33805C11.2019 6.03797 11.1902 5.56325 10.8901 5.27771L6.00013 0.624662C5.70006 0.339128 5.22533 0.350913 4.9398 0.650985C4.65426 0.951057 4.66605 1.42578 4.96612 1.71132L9.31275 5.84736L5.1767 10.194C4.89117 10.4941 4.90295 10.9688 5.20302 11.2543C5.50309 11.5399 5.97782 11.5281 6.26336 11.228L10.9164 6.33805ZM0.384898 6.81922L10.3917 6.57081L10.3545 5.07127L0.347672 5.31969L0.384898 6.81922Z" /></svg>'
      ],
      loop:($(this).data("loop")) ? true :false,
      
      rewind: ($(this).data("rewind")) ? true :false,
      nav:($(this).data("nav")) ? true :false,
      rewind: ($(this).data("rewind")) ? true :false,
      rtl:rtlFlag,
      autoplay:($(this).data("autoplay")) ? true :false,
      dots:($(this).data("dots")) ? true :false,
      autoplayTimeout:($(this).data("autoplaytimeout")) ? $(this).data("autoplaytimeout") :4000,
      smartSpeed: ($(this).data("smartspeed")) ? $(this).data("smartspeed") :500,
      margin:($(this).data("margin")) ? $(this).data("margin") : 0,
      responsive: {
        0: {
          items: $(this).data("small")
        },
        544: {
          items: $(this).data("mobile")
        },
        768: {
          items: $(this).data("tablet")
        },
        992: {
          items: $(this).data("laptop")
        },
        1200: {
          items: $(this).data("desktop")
        }
      }
    });
  });
  // INITIALIZE JS END
  
  //COUNTDOWN TIMER START
  $('[data-deal="1"]').each(function( index ) {
    setCountDownTimer($(this).data("counter"), this.querySelector(".countdowncontainer"));
  });
  //COUNTDOWN TIMER END
  
  //WRITE COMMENT JS START
  $(".write_comment").click(function(e) {
    $('.ishi-product-tab .ishi-nav-tabs a.review-tab').trigger('click');
    $('html, body').animate({scrollTop: $(".ishi-product-tab").offset().top - 50}, 2000);
  });
  //WRITE COMMENT JS END
  
  //fixed header
  adjustFixedHeader();
  $(window).scroll(function(){
    adjustFixedHeader();
  });
  
  
  var shopify_responsive_current_width = window.innerWidth;
  var shopify_responsive_min_width = 992;
  var shopify_responsive_mobile = shopify_responsive_current_width < shopify_responsive_min_width;

  if (shopify_responsive_mobile) {
    convertToMobile();
  }
  
  $(window).on('resize', function () {
    var _mw = shopify_responsive_min_width;
    var _w = window.innerWidth;
    var desktopContent = $("*[id^='_desktop_']").first().html().trim().length;
    var mobileContent = $("*[id^='_mobile_']").first().html().trim().length;
    if(_w < _mw && desktopContent) {
      convertToMobile();
    } 
    if(_w >= _mw && mobileContent) {
      convertToDesktop();
    } 
  });
  
  $('#menu-icon').on('click', function() {
    $("#mobile_top_menu_wrapper").animate({
      width: "toggle"
    });
    $('.mobile-menu-overlay').toggleClass("active");
  });

  $('#top_menu_closer svg').on('click', function() {
    $("#mobile_top_menu_wrapper").animate({
      width: "toggle"
    });
    $('.mobile-menu-overlay').toggleClass("active");
  });
  
  $('.mobile-menu-overlay').on('click', function() {
    $("#mobile_top_menu_wrapper").animate({
      width: "toggle"
    });
    $('.mobile-menu-overlay').toggleClass("active");
  });

  $('.cart-drawer-toggler').on('click', function() {
    openCartDrawer();
  });

  $('#cart-notification-closer svg').on('click', function() {
    closeCartDrawer();
  });
  
  $('.cart-overlay').on('click', function() {
    closeCartDrawer();
  });
  
   
});

//ISHI FUNCTIONS START

function convertToMobile(){
  //interchange sections

  $("*[id^='_desktop_']").each(function(index, element) {
    var target = $('#' + element.id.replace('_desktop_', '_mobile_'));
    swapElements($(this), target);
  });
  $(window).scroll(function () {
    if ($(this).scrollTop() > 1000) {
      $('.sticky-cartbtn').fadeIn(500);
    } else {
      $('.sticky-cartbtn').fadeOut(500);
    }
    });
  $(".stickyaddtocart").show(); 
}
function convertToDesktop() {
  //interchange sections

  $("*[id^='_mobile_']").each(function(index, element) {
    var target = $('#' + element.id.replace('_mobile_', '_desktop_'));
    swapElements($(this), target);
  });
  $("#main-media-container").length ? $("#main-media-container img").elevateZoom({zoomType: "inner", cursor: "crosshair"}): "";
  	$(".stickyaddtocart").hide();

}

function swapElements(source, destination) {
  var temp = destination.children().detach();
  destination.empty().append(source.children().detach());
  source.append(temp);
}



function adjustFixedHeader() {
    var headerHeight = $('#header').height();
  	var navmenuHeightDesktop = $('.wrapper-nav .navfullwidth').height();
    var navfullwidthHeightDesktop = headerHeight + navmenuHeightDesktop;
    var navHeightMobile = $('#header').height();
    if(window.matchMedia('(min-width: 992px)').matches) {
      $('.mobile-width').removeClass('fixed-header');
      if ($(window).scrollTop() > navfullwidthHeightDesktop) {
        $('.header-top ').addClass('fixed-header');
      }
      else {
        $('.header-top ').removeClass('fixed-header');
      }
    }
    if(window.matchMedia('(max-width: 991px)').matches) {
      $('.navfullwidth').removeClass('fixed-header');
      if ($(window).scrollTop() > navHeightMobile) {
        $('.mobile-width').addClass('fixed-header');
      }
      else {
        $('.mobile-width').removeClass('fixed-header');
      }    
    }
}
   
   
   
      

$(function() {
  // Current Ajax request.
  var currentAjaxRequest = null;
  // Grabbing all search forms on the page, and adding a .search-results list to each.
  var searchForms = $('form[action="/search"]').css('position','relative').each(function() {
    // Grabbing text input.
    var input = $(this).find('input[name="q"]');
    // Adding a list for showing search results.
    var offSet = input.position().top + input.innerHeight();
    $('<ul class="search-results"></ul>').css( { 'position': 'absolute', 'left': '0px', 'top': offSet } ).appendTo($(this)).hide();    

    // Listening to keyup and change on the text field within these search forms.
    input.attr('autocomplete', 'off').bind('keyup change', function() {
      // What's the search term?
      var term = $(this).val();
      if(term !== ""){
        $(".search-header .search-results").show();
        $(".search-header .suggestion-tags").hide();
      } else {
        $(".search-header .search-results").hide();
        $(".search-header .suggestion-tags").show();
      }
      // What's the search form?
      var form = $(this).closest('form');
      // What's the search URL?
      var searchURL = '/search?type=product&q=' + term;
      // What's the search results list?
      var resultsList = form.find('.search-results');
      // What's the suggestion tags container?
      // var suggestionTagsContainer = form.find('.suggestion-tags');
      
      // If that's a new term and it contains at least 3 characters.
      if (term.length > 3 && term != $(this).attr('data-old-term')) {
        // Saving old query.
        $(this).attr('data-old-term', term);
        // Killing any Ajax request that's currently being processed.
        if (currentAjaxRequest != null) currentAjaxRequest.abort();
        // Pulling results.
        currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {
          // Reset results.
          resultsList.empty();
          // suggestionTagsContainer.empty(); // Clear existing suggestion tags.

          // If we have no results.
          if(data.results_count == 0) {
            // resultsList.html('<li><span class="title">No results.</span></li>');
            // resultsList.fadeIn(200);
            resultsList.hide();
          } else {
            // If we have results.
            $.each(data.results, function(index, item) {
              var link = $('<a></a>').attr('href', item.url);
              link.append('<span class="thumbnail"><img src="' + item.thumbnail + '" /></span>');
               link.append('<span class="type">' + item.type + '</span>');
              link.append('<span class="title">' + item.title + '</span>');
              link.append('<span class="price">' + item.price + '</span>');
              link.wrap('<li></li>');
              resultsList.append(link.parent());
            });

            // // Extract suggestion tags from the results and display them.
            // var suggestionTags = getSuggestionTags(data.results);
            // suggestionTagsContainer.html('<strong>Trending:</strong> ' + suggestionTags.join(', ')).fadeIn(200);

            // resultsList.fadeIn(200);
          }        
        });
      }
    });
  });

  $(document).on("click",".variants-swatch .color-box",function() {
  	var image = this.getAttribute("data-image");
    $(this).parents('.variants-swatch').find('.swatch-label').removeClass('active');
    $(this).parents('.swatch-label').addClass('active');
    $(this).parents('.card-wrapper').find('.thumbnail .primary-image').attr('src', image);
    $(this).parents('.card-wrapper').find('.thumbnail .primary-image').attr('srcset', image);
  });

 


  $(document).on('click', '.item-swatch-more .number-showmore', (event) => {
    if ($(event.target).closest('.variants-swatch').hasClass('show--more')) {
      $(event.target).closest('.variants-swatch').removeClass('show--more');
    }
    else{
      $(event.target).closest('.variants-swatch').addClass('show--more');
    }
  });
});

//QUICKVIEW FUNCTIONS START

var variantAvailability = [];
var variantFeaturedImg = [];
var variantIndexIdMapping = [];
var currentVariants = {};
var availableVariants = [];
var variantCompareAtPrice = [];
var variantPrice = [];

function loadQuickView(handle,btn) {
  variantAvailability = [];
  variantFeaturedImg = [];
  variantIndexIdMapping = [];
  currentVariants = {};
  availableVariants = [];
  variantCompareAtPrice = [];
  variantPrice = [];
  $("#qv-variants").html('');
  
  jQuery.getJSON('/products/' + handle + '.js', function (product) {
    $("#qv-productname").html(product.title);
    $("#qv-productdescription").html(product.description);
    if(product.description.length < 300) {
    	$(".more-description").css("display","none");
    }else{
        $(".more-description").css("display","block");
    }

    $(product.variants).each(function(index,variant) {

      var variantsList = variant.title.split("/");
      var variantsKeyVal = {};
      for(var i=0; i < variantsList.length; i++) {
        variantsKeyVal["select-option" + (i+1)] = variantsList[i].trim();
      }
     variantIndexIdMapping.push(variant.id);
     availableVariants.push(variantsKeyVal);
      variantAvailability.push(variant.available);
    //  variantFeaturedImg.push(variant.featured_image.src);
      variantCompareAtPrice.push(variant.compare_at_price);
      variantPrice.push(variant.price);
      
      var variant = product.variants[0];
      $("#qv-variantid").val(variant.id);
      
      if(variant.compare_at_price != null && variant.compare_at_price > variant.price) {
        $("#qv-compareatprice").html(convertToMoney(variant.compare_at_price));
        $("#qv-price").html(convertToMoney(variant.price));
      } else {
        $("#qv-compareatprice").html('');
        $("#qv-price").html(convertToMoney(variant.price));
      }
    });

   
    
    $("#qv-product-cover img").attr("src",product.featured_image);
    var reviews = $('[data-handle="'+ handle +'"]').parents(".card-wrapper").find(".spr-badge").clone();
    $("#qv-spr-badge").html(reviews.html());

    //prepare thumbnails
    prepareQvThumbnails(product.images);

    if(product.variants.length > 1) {
       console.log('Variants length:', product.variants.length);
      //prepare swatches
      var colorNameList = "color,colour,couleur,colore,farbe,색,色,färg,farve";
      colorNameList = colorNameList.split(",");
      $(product.options).each(function (i, option) {
        var name = option.name;
        var includesColor = colorNameList.includes(name.toLowerCase());
        var swatchWrapper = $('<div class="swatch-wrapper" data-index="' + option.position + '"></div>');
         var optionValues =  $('<div class="option-values product-form__input ' + name.toLowerCase() +'"></div>');
        swatchWrapper.append('<div class="option-label"><label>' + name + '</label></div>')
        $(option.values).each(function (i, value) {
          var checked = '';
          if(i==0) checked = 'checked';
          optionValues.append('<input id="' + name + '-' + i + '" type="radio" value="' + value + '" name="' + name +'"' + checked  +'>');
          var className = (includesColor || value.length < 3) ? "square" : "label"; 
          if(includesColor) {
            var dummyImg = "//mariasenxoval.com.br/cdn/shop/files/dummy?v=12752";
            var dummyImgURL = dummyImg.substr(0, dummyImg.indexOf('dummy'));
            var dummyImgVersion = dummyImg.substr(dummyImg.indexOf('?'));
            var imgURL = "background-color:" + value + "; background-image: url('"+ dummyImgURL + value + ".png" + dummyImgVersion +"')";
          	optionValues.append('<label style="'+ imgURL + '" for="' + name + '-' + i + '" data-color="' + value +'" data-index="'+ i +'"></label>');
          } else {
            optionValues.append('<label for="' + name + '-' + i + '" class="' + className +'" data-index="'+ i +'">' + value + '</label>');
          }
          
        });
        swatchWrapper.append(optionValues);
        $("#qv-variants").append(swatchWrapper);
      });    

      //prepare dropdown
      $(product.options).each(function (i, option) {
        var name = option.name;
        var selectWrapper = $('<div class="dropdown-wrapper"></div>');
        var optionValues = $('<div class="option-values product-form__input"></div>');
        var selectBoxWrapper =  $('<div class="select"></div>');
        var selectBox =  $('<select id="select-option' + option.position + '" name="options[' + option.position + ']" class="select__select"></select>');
        selectWrapper.append('<div class="option-label"><label>' + name + '</label></div>')
        $(option.values).each(function (i, value) {
          var selected = '';
          if(i==0) selected = 'selected';
          selectBox.append('<option value="' + value +'" ' + selected +'>' + value + '</option>');
        });
        selectBoxWrapper.append(selectBox);
        optionValues.append(selectBoxWrapper);
        selectWrapper.append(optionValues);
        $("#qv-variants").append(selectWrapper);
         
      });
      
      $(product.variants).each(function(index,variant) {
        var variantsList = variant.title.split("/");
        var variantsKeyVal = {};
        for(var i=0; i < variantsList.length; i++) {
          variantsKeyVal["select-option" + (i+1)] = variantsList[i].trim();
        }
        variantIndexIdMapping.push(variant.id);
        availableVariants.push(variantsKeyVal);
        variantAvailability.push(variant.available);
      
        // Check if featured_image is not null before accessing its src property
        if (variant.featured_image) {
        variantFeaturedImg.push(variant.featured_image.src);
        } else {
            variantFeaturedImg.push(null); // or a default image URL if you prefer
        }

        variantCompareAtPrice.push(variant.compare_at_price);
        variantPrice.push(variant.price);
      });
      loadCurrentQvVariants();
      updateQvVariantDetails();
    } else {
      // var variant = product.variants[0];
      // $("#qv-variantid").val(variant.id);
      
      
      if(variant.available){
      	$("#qv-add-to-cart").removeClass("sold-out");
      } else {
      	$("#qv-add-to-cart").addClass("sold-out");
      }
      // $(product.variants).each(function(index,variant) {
      //    var variant = product.variants[index];
      //    alert(variant.id);
      //   $("#qv-variantid").val(variant.id);
      //     if(variant.compare_at_price != null && variant.compare_at_price > variant.price) {
      //       $("#qv-compareatprice").html(convertToMoney(variant.compare_at_price));
      //       $("#qv-price").html(convertToMoney(variant.price));
      //     } else {
      //       $("#qv-compareatprice").html('');
      //       $("#qv-price").html(convertToMoney(variant.price));
      //     }
      // //index++
      // });
    }
    $('.qv-wrapper').removeClass('loading');
  });
}


function prepareQvThumbnails(images) {
  var rtlFlag = ($('body').hasClass('lang-rtl')) ? true : false;
	var thumbnailContainer = $('#qv-thumbnails');
    var thumbnailSliderWrapper = $('<div class="owl-carousel"></div>')
    $(images).each(function (i,src) {
      thumbnailSliderWrapper.append('<div class="thumb-item item"><img data-src="' + src +'" alt="qv-img" class="lazyload"></div>');
    });
    thumbnailContainer.html(thumbnailSliderWrapper);
    thumbnailSliderWrapper.owlCarousel({
      nav: true,
      navText: [
        '<i class=\'fa fa-angle-left\'></i>',
        '<i class=\'fa fa-angle-right\'></i>'
      ],
      dots: false,
      loop: false,
      margin:15,
      rtl: rtlFlag,
      rewind:true,
      responsive: {
        0: {
          items: 3
        },
        544: {
          items: 4
        },
        768: {
          items: 3
        },
        992: {
          items: 4
        },
        1200: {
          items: 4
        }
      }
  	});

}

function loadCurrentQvVariants() {
  //load current variants
  $('#qv-variants .dropdown-wrapper').each(function(index){
    currentVariants["select-option" + (index+1)] = $(this).find('select.select__select').val();
  });
}

function updateQvVariantDetails() {
  var index = -1;
  var available = false;

  // Find the index of the selected variant
  for (var i = 0; i < availableVariants.length; i++) {
    if(matchArray(availableVariants[i],currentVariants)) {
      index = i;
      if (variantAvailability[i]) {
      available = true;
      break;
    }
    }
  }
  
  // Update the variant ID, price, and availability
  if (index !== -1) {
  $("#qv-variantid").val(variantIndexIdMapping[index]);
  
    if (variantAvailability[index]) {
    $("#qv-add-to-cart").removeClass("sold-out");
  } else {
    $("#qv-add-to-cart").addClass("sold-out");
  }
  
    var compare_at_price = variantCompareAtPrice[index];
    var price = variantPrice[index];
  
  if(compare_at_price != null && compare_at_price > price) {
    $("#qv-compareatprice").html(convertToMoney(compare_at_price));
    $("#qv-price").html(convertToMoney(price));
  } else {
    $("#qv-compareatprice").html('');
    $("#qv-price").html(convertToMoney(price));
  }

    // Update the featured image if available
    if (variantFeaturedImg[index]) {
      $("#qv-product-cover img").attr("src", variantFeaturedImg[index]);
    }
  }
}

function matchArray(a, b) {
  var match = true;
  for (var key in a) {
    if(a[key] != b[key]) {
      match = false;
    }
  }
  return match;
}

$(document).on("change","#qv-variants .select__select",function(){
  loadCurrentQvVariants();
  updateQvVariantDetails();
});
 
$(document).on("click",".swatch-wrapper label",function() {
  var selectorIndex = $(this).parents(".swatch-wrapper").data("index");
  var selector = "#select-option" + selectorIndex  + " option";
  var index = $(this).data("index");
  $(selector).eq(index).prop('selected', true).trigger('change');
});

$(document).on("click",".thumb-item",function(){
  $("#qv-product-cover img").attr("src",$(this).find("img").attr("src"))
});

$(document).on("click","#qv-add-to-cart",function(){
  if($(this).hasClass("sold-out")) return false;
  var variantId = $("#qv-variantid").val();
  var qty = $("#qv-quantity-selector input").val();
  $(this).addClass("loading");
  addToCartJS(qty,variantId, this);
  $("#ModalClose-quick-view").trigger("click");
});

//QUICKVIEW FUNCTIONS END
if(window.matchMedia('(max-width: 991px)').matches) { 
	    $(window).scroll(function () {
	      if ($(this).scrollTop() > 1000) {
	        $('.sticky-cartbtn').fadeIn(500);
	      } else {
	        $('.sticky-cartbtn').fadeOut(500);
	      }
	    });
  
	  }
	  $(document).on("click", ".stickyaddtocart", function() {
	    $(".product-form__submit").trigger('click');
	  }); 

//ISHI FUNCTIONS END

if (window.matchMedia('(max-width: 1199px)').matches) {
 
   $(".ishi-faq-section .collapse_item").click(function(){
     $('html, body').animate({
       scrollTop: $(".ishi-faq-section").offset().top - 70
     }, 1000);
   });
}
//ISHI FUNCTIONS END 



//   document.addEventListener("DOMContentLoaded", function() {
//     var cartUpsell = document.getElementById('cart-upsell');
//     var cartDrawerGift = document.getElementById('cart-drawer-gift');
//     cartUpsell.style.display = 'none';
//     cartDrawerGift.style.display = 'none';
//     function handleCartChanges() {
//         var cartEmpty = document.querySelector('.cart-empty');
//         if (!cartEmpty) {
//             cartUpsell.style.display = 'block';
//             cartDrawerGift.style.display = 'block';
//             console.log("cart is not Empty-------");
//         } else {
//           alert(cartEmpty);
          
//             cartUpsell.style.display = 'none';
//             cartDrawerGift.style.display = 'none';
//           console.log("cart is Empty-------");
          
//         }
//     }
//     handleCartChanges();
//     document.addEventListener('DOMSubtreeModified', handleCartChanges);
// });

// document.addEventListener("DOMContentLoaded", function () {
//     var cartUpsell = document.getElementById('cart-upsell');
//     var cartDrawerGift = document.getElementById('cart-drawer-gift');
//     cartUpsell.style.display = 'none';
//     cartDrawerGift.style.display = 'none';

//     function handleCartChanges() {
//         var cartEmpty = document.querySelector('.cart-empty');
//         if (!cartEmpty) {
//             cartUpsell.style.display = 'block';
//             cartDrawerGift.style.display = 'block';
//             console.log("Cart is not empty");
//         } else {
//             cartUpsell.style.display = 'none';
//             cartDrawerGift.style.display = 'none';
//             console.log("Cart is empty");
//         }
//     }

//     // Initial check
//     handleCartChanges();

//     // Observe cart container for changes
//     var cartContainer = document.querySelector('#CartContainer'); // Replace with the actual cart container ID/class

//     if (cartContainer) {
//         const observer = new MutationObserver(function (mutationsList, observer) {
//             handleCartChanges();
//         });

//         observer.observe(cartContainer, { childList: true, subtree: true });
//     } else {
//         console.warn("Cart container not found");
//     }
// });

// Add on upsell product js start

function showPopup(p_id) {
    const overlay = document.getElementById('overlay_' + p_id);
    const popup = document.getElementById('popup_' + p_id);

    overlay.style.display = 'block';
    popup.classList.add('active');

    // // Adding event listener to the close button
    // const closeBtn = document.getElementById('closeBtn');
    // closeBtn.addEventListener('click', function() {
    //     hidePopup(p_id);
    // });
document.body.addEventListener('click', function(event) {
    // Check if the clicked element is a close button
    if (event.target && event.target.id === 'closeBtn') {
        // Find the parent popup element ID
        const popupId = event.target.closest('.popup').id.split('_')[1];
        // Call hidePopup function with the popup ID
        hidePopup(popupId);
    }
});
    // Adding event listener to the overlay
    overlay.addEventListener('click', function(event) {
        if (event.target === overlay) {
            hidePopup(p_id);
        }
    });
}

function hidePopup(p_id) {
    const overlay = document.getElementById('overlay_' + p_id);
    const popup = document.getElementById('popup_' + p_id);

    overlay.style.display = 'none';
    popup.classList.remove('active');
}

document.addEventListener('DOMContentLoaded', function () {
    const popups = document.querySelectorAll('.upsell-product-popup');
    
    popups.forEach(function(popup, index) {
        const cartBtn = popup.querySelector('.popupbtn');
        const p_id = cartBtn.dataset.productId;

        cartBtn.addEventListener('click', function() {
            showPopup(p_id);
        });
    });
});
document.addEventListener('DOMContentLoaded', function() {
    const addToCartButtons = document.querySelectorAll('.ajax-cart-btn');
    addToCartButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            const popupId = this.closest('.popup').id.split('_')[1];
            hidePopupWithTransition(popupId);
        });
    });
});
function hidePopupWithTransition(p_id) {
    const popup = document.getElementById('popup_' + p_id);
    popup.style.transition = 'opacity 0.5s';
    // Set opacity to 0 with a transition effect
    popup.style.opacity = '0';
    // Hide the popup after the transition ends
    setTimeout(function() {
        hidePopup(p_id);
    }, 500);
}
function hidePopup(p_id) {
    const overlay = document.getElementById('overlay_' + p_id);
    const popup = document.getElementById('popup_' + p_id);
    overlay.style.display = 'none';
    popup.classList.remove('active');
    // Restore opacity to 1 after hiding the popup
    popup.style.opacity = '1';
}

$(document).ready(function() {
  $(".Add-on").on("click", function() {
    $(this).parents(".variants-swatch").find(".Add-on").removeClass("active");
    $(this).addClass("active");
    var popupSelector = $(this).parents(".popup").attr("id");
    var valuesArray = "";
    $(this).parents(".popup").find(".Add-on.active").each(function() {
      var optionValue = $(this).data("value");
      valuesArray = `${valuesArray} ${optionValue}`;
    }); 
    var trimmedValue = String(valuesArray).trim();
        selectedVariant = $(`#${popupSelector} .select__select option[data-variant="${trimmedValue}"]`);
        onChangeGetVariantID = selectedVariant.attr("value");
    $(this).parents(".popup").find(".product-form input[name='id']").val(onChangeGetVariantID);
  }); 
});
buttonTextChange();
function buttonTextChange() {
  if (window.location.href.indexOf("products") > -1){
    $(".upsell-product").each(function(){
     var upsellProductHandle = $(this).data("handle");
     $.ajax({
         type: 'GET',
         url: '/cart.json',
         dataType: 'jsonp',
         success: function(data) {
           var items = data['items'];
           for (var i = 0; i < items.length; i++) {
               if (items[i]["handle"] == upsellProductHandle) {
                 $(".upsell-product[data-handle="+upsellProductHandle+"] .popupbtn span").text("Added");
               }
           }
         }
     });
    });
  }
}
$(document).on("click", ".ishi-nav-link", function(e) {
  e.preventDefault();

  // Remove active class from all tabs
  $(this).closest(".ishi-nav-tabs").find(".ishi-tab-item").removeClass("active");

  // Add active class to clicked tab
  $(this).closest(".ishi-tab-item").addClass("active");

  // Remove active class from all tab contents
  $(this).closest(".ishi-product-tab").find(".ishi-tab-pane").removeClass("active");

  // Get the target content selector from data-href
  var target = $(this).data("href");

  // Activate the target tab content
  $(target).addClass("active");

  // Scroll smoothly to the content
  if ($(target).length) {
    $('html, body').animate({
      scrollTop: $(target).offset().top - 80
    }, 500);
  }
});
function toggleUpsellShippingInner() {
  var upsellShippingInner = document.getElementById('cart-upsell-shipping-inner');

  // Change this selector according to your cart item wrapper
  var cartItems = document.querySelectorAll('.cart-items .cart-item');

  if (cartItems.length === 0) {
    upsellShippingInner.style.display = 'none';
    console.log('No items in cart – upsell shipping hidden');
  } else {
    upsellShippingInner.style.display = 'block';
    console.log('Cart has items – upsell shipping visible');
  }
}
